import _ from 'lodash'

function isDynamicPage(routers, pageId: string) {
    return _.some(routers, routerData => _.includes(_.values(routerData.pages), pageId))
}

export default {
    isDynamicPage
}
